// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"6d868226","787":"a227f313","975":"757aec10"}[chunkId] + ".chunk.js";
};